import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminContactUs from "../../../views/admin/cms/AdminContactUs";

const AdminContactUsPageList = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminContactUs />
      <AdminFooter />
    </div>
  );
};

export default AdminContactUsPageList;
